import Vue from 'vue'
import App from './App.vue'
import { router } from './router/router'
import  { store   } from './store/store'

// scroll to
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)


window.eventBus = new Vue()

new Vue({
  el: '#app',
  router,
  store: store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js